const PLATFORM_TITLE_DEFAULT: string = 'The Platform';

export default PLATFORM_TITLE_DEFAULT;
